<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <Button icon="ios-arrow-back" size="small" class="mr20" @click="$router.go(-1)">返回</Button>
        <span class="ivu-page-header-title mr20" v-text="$route.meta.title"></span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="formData" :model='deviceData' label-position="right" :label-width="200" @submit.native.prevent>
        <Row :gutter="24" type="flex">

          <Col span="24">
            <FormItem label="设备编号">
              <Input disabled="disabled" v-model="deviceData.device_sn" class="perW30"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="设备类型">
              <Input disabled="disabled" v-model="deviceData.title" class="perW30"></Input>
            </FormItem>
          </Col>

          <Col span="24">
            <FormItem label="所在基地">
              <Input disabled="disabled" v-model="deviceData.land_base" class="perW30"></Input>
            </FormItem>
          </Col>

          <template v-for="(item, index) in this.deviceData.values">

            <Col span="24">
              <FormItem :label="item.name" >
                <Input v-model="item.value" class="perW30"></Input>
              </FormItem>
            </Col>

          </template>

        </Row>

        <FormItem>
          <Button type="primary" class="submission" @click="submitFormData">提交</Button>
        </FormItem>

      </Form>
    </Card>
  </div>
</template>

<script>
import {deviceInfoApi, deviceSaveApi} from '@/api/device/device'

export default {
  name: 'deviceEdit',
  data() {
    return {
      deviceData: {
        id: 0,
        device_sn: '',
        title: '',
        land_base: '',
        values: [],
      },
    }
  },
  mounted() {
    if (this.$route.params.id !== '0' && this.$route.params.id) {
      this.loadFormData(this.$route.params.id)
    }
  },
  methods: {
    // 提交数据
    submitFormData() {
      deviceSaveApi({
        id: this.deviceData.id,
        values: this.deviceData.values
      }).then(res => {
        if (res.code === 200) {
          this.$Message.success('成功')
          setTimeout(() => {
            this.$router.go(-1)
          }, 500)
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 编辑加载数据
    loadFormData(id) {
      deviceInfoApi(id).then(res => {
        // 数据赋值
        this.deviceData = res.data

      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },


  }
}
</script>
